document.addEventListener('DOMContentLoaded', function () {
  const selectCountry = document.getElementById('select-country');
  const inputZipCode = document.querySelector('input[type="text"]');
  const listStores = document.querySelectorAll('.content__store');
  const noStoreItem = document.querySelector('.no-store');
  function filterStores() {
    const chosenCountry = selectCountry.value;
    const enteredZipCode = inputZipCode.value.toLowerCase();
    let storeFound = false;
    listStores.forEach(store => {
      const storeCountry = store.getAttribute('data-country');
      const storeZipCode = store.getAttribute('data-zipcode').toLowerCase();
      if ((chosenCountry === '' || storeCountry === chosenCountry) && (storeZipCode.startsWith(enteredZipCode) || enteredZipCode === '')) {
        store.classList.remove('visually-hidden');
        storeFound = true;
      } else {
        store.classList.add('visually-hidden');
      }
    });
    if (!storeFound) {
      noStoreItem.classList.remove('visually-hidden');
    } else {
      noStoreItem.classList.add('visually-hidden');
    }
  }
  selectCountry.addEventListener('change', filterStores);
  inputZipCode.addEventListener('input', filterStores);
});